import React, { createContext, useState } from "react";
import { useEffect } from "react";
import {
  getItemStorage,
  setItemStorage,
} from "../Localstorage/useLocalStorage";

export const compareDataContext = createContext();

const CompareContext = ({ children }) => {
  const [compareData, setCompareData] = useState([]);
  const [openCompare, setOpenCompare] = useState(false);
  const [once, setOnce] = useState(true);

  useEffect(() => {
    if (once) {
      setOnce(false);
      
      setCompareData(
        getItemStorage("compare") ? JSON.parse(getItemStorage("compare")) : []
      );
    }

    compareData.length === 0 && setOpenCompare(false);

    setItemStorage("compare", JSON.stringify(compareData));
  }, [compareData]);

  return (
    <compareDataContext.Provider
      value={{ compareData, setCompareData, openCompare, setOpenCompare }}
    >
      {children}
    </compareDataContext.Provider>
  );
};

export default CompareContext;
